import React, { useEffect } from 'react'
import { Box as Card, Box as Container, Box as Group } from '@node-space/ui-components'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import { MassPayoutLanding } from './pages/MassPayoutLanding'

export const MassPayouts = () => {
  useEffect(() => {
    track.Amp.track(AmplitudeEvent.MASS_PAYOUTS, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.VIEW,
    })
  }, [])

  return (
    <Card>
      <Container flexCol centerChildren gapY={24}>
        <Group
          flexCol
          centerChildren
          gapY={24}
          className="w-full"
          id="mass-payouts-header-card-description"
          testId="mass-payouts-header-card-description"
        >
          <MassPayoutLanding />
        </Group>
      </Container>
    </Card>
  )
}
